export default __webpack_public_path__ + "static/media/20f77a35e3acdad42ef4be3487055f8a.svg";